import ApiHelper from './index';

const sendSQSMessage = async (payload, spinner = true) => {
  return await ApiHelper.post('generic/send_sqs_message/', payload, spinner);
};

export default {
  sendSQSMessage,
};
